import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Store, Tablet } from 'lucide-react-native'
import { colors } from '@chillout/core'
import { SuccessInfoRow } from '../../../shared/SuccessInfoRow'
import { DevicePairingCodeCard } from '../DevicePairingCodeCard'

interface AddDeviceSuccessProps {
  deviceName: string
  branchName: string
  pairingCode: string
  formattedCode: string
  expiresAt: Date | null
  onCopy: () => void
}

export function AddDeviceSuccess({ deviceName, branchName, pairingCode, formattedCode, expiresAt, onCopy }: AddDeviceSuccessProps) {
  const { t } = useTranslation()
  return (
    <View className="mt-4 gap-4">
      <SuccessInfoRow
        left={{ icon: <Tablet size={20} color={colors.text.secondary} strokeWidth={2} />, label: deviceName }}
        right={{ icon: <Store size={20} color={colors.text.secondary} strokeWidth={2} />, label: branchName }}
      />
      <Text className="text-sm font-normal text-secondary">
        {t('operations.addDevice.successDescription')}
      </Text>
      <DevicePairingCodeCard
        pairingCode={pairingCode}
        formattedCode={formattedCode}
        expiresAt={expiresAt}
        copyAccessibilityLabel={t('operations.addDevice.copyCodeAccessibilityLabel')}
        showCopyIcon={false}
        onCopy={onCopy}
      />
    </View>
  )
}
